import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastTypes, useMessage } from '../../../../base/context/MessageProvider';
import { SubscriptionApiService } from '../../../../service/website/subscriptionApiService';
import AlibabaSubscriptionApiService from '../../../../network/apiServices/AlibabaSubscriptionApiService';
import WebButton from '../../../../component/library/webButton';
import { AiFillHeart } from 'react-icons/ai'

// const SubscribeButton = ({ product, searchKeyword = '', isLoggedIn = false }) => {
const SubscribeButton = ({ product, priceRanges, searchKeyword = '', isLoggedIn = false, sp = null, variantDetails = {}}) => {
  const message = useMessage();
  const navigate = useNavigate();
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Check if this is an Alibaba product
  const isAlibabaProduct = product?.location === 'global' || product?.source === 'alibaba' || product?.location === 'alibaba';

  // Check subscription status on component mount
  useEffect(() => {
    const checkSubscriptionStatus = async () => {
      if (isLoggedIn && product?.sku) {
        // For Alibaba products, check if user is subscribed by checking both products and drafts
        if (isAlibabaProduct) {
          try {
            const res = await AlibabaSubscriptionApiService.checkSubscriptionStatus(product.sku);
            if (res.status.code === 200 && res.data) {
              setIsSubscribed(res.data.isSubscribed || false);
            } else {
              setIsSubscribed(false);
            }
          } catch (err) {
            console.error('Error checking Alibaba subscription status:', err);
            setIsSubscribed(false);
          }
        } else {
          // For regular products, use the subscribe field from database
          setIsSubscribed(product.subscribe || false);
        }
      } else {
        setIsSubscribed(false);
      }
    };

    checkSubscriptionStatus();
  }, [isLoggedIn, isAlibabaProduct]);

  const handleSubscribe = async () => {
    if (!isLoggedIn) {
      navigate('/login');
      message.showToast('To subscribe product please login', ToastTypes.WARNING);
      return;
    }

    setIsLoading(true);

    try {
      if (isSubscribed) {
        // Unsubscribe logic
        if (isAlibabaProduct) {
          const res = await AlibabaSubscriptionApiService.unsubscribeFromProduct(product.sku);
          if (res.status.code === 200) {
            setIsSubscribed(false);
            message.showToast(res.status.message, ToastTypes.SUCCESS);
          } else {
            message.showToast(res.error.message, ToastTypes.ERROR);
          }
        } else {
          const res = await SubscriptionApiService.unSubscribeProduct(product.sku);
          if (res.status.code === 200) {
            setIsSubscribed(false);
            message.showToast(res.status.message, ToastTypes.SUCCESS);
          } else {
            message.showToast(res.error.message, ToastTypes.ERROR);
          }
        }
      } else {
        // Subscribe logic
        const finalSearchKeyword = searchKeyword?.trim() || '';
        if (isAlibabaProduct) {
          const fromPDP = true;
          const variations = Object.values(variantDetails);
          const res = await AlibabaSubscriptionApiService.subscribeToProduct(product.sku, priceRanges, fromPDP, finalSearchKeyword, sp , variations, product.title);
          if (res.status.code === 200) {
            setIsSubscribed(true);
            message.showToast('Product subscribed successfully!', ToastTypes.SUCCESS);
          } else {
            message.showToast(res.error.message, ToastTypes.ERROR);
          }
        } else {
          const res = await SubscriptionApiService.subscribeProduct(product.sku, finalSearchKeyword);
          if (res.status.code === 200) {
            setIsSubscribed(true);
            message.showToast(res.status.message, ToastTypes.SUCCESS);
          } else {
            message.showToast(res.error.message, ToastTypes.ERROR);
          }
        }
      }
    } catch (err) {
      console.error('Subscription error:', err);
      if (isSubscribed && isAlibabaProduct) {
        // message.showToast(err?.message || 'Server error. Try again later', ToastTypes.ERROR);
      } else {
        message.showToast(err?.message || 'Server error. Try again later', ToastTypes.ERROR);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <WebButton
      className={
        isSubscribed
          ? 'w-full py-2 bg-[#3DD0E5] text-white hover:!text-black border border-[#3DD0E5] hover:border-black rounded-full hover:bg-white hover:text-black transition-colors font-medium text-[14px] disabled:opacity-50 disabled:cursor-not-allowed'
          : 'w-full py-2 bg-black text-white hover:text-black border border-black hover:border-black rounded-full hover:bg-white hover:text-black transition-colors font-medium text-[14px] disabled:opacity-50 disabled:cursor-not-allowed'
      }
      type="button"
      text={isLoading ? 'Processing...' : isSubscribed ? 'Unsubscribe' : 
        (
          <span className="flex items-center justify-center gap-2">
            <AiFillHeart className="w-4 h-4 text-white" />
            <span>Subscribe Now</span>
          </span>
        )
      }
      onClick={handleSubscribe}
      disabled={isLoading}
    />
  );
};

export default SubscribeButton;
